import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./AboutPage.scss";
import { motion } from "framer-motion";
import TypeIt from "typeit-react";
import FroiCards from "../../components/About/FroiCards";
import MetaTagsSeo from "../../components/Shared/MetaTagsSeo";
function AboutPage() {
  return (
    <>
      <MetaTagsSeo
        title="FROI – About"
        description="FROI is grounded in a rigorous scientific methodology engineered to navigate the demands of the New Economy , Future Ways of Work, as well as to empower the government human capital ecosystem to transition from merely anticipating the future to actively shaping it."
        keywords={[
          "FUTURE READY ORGANIZATION INSTITUTE",
          "Future Ready",
          "Future Ready Organization",
          "Future Ready Government",
          "Future Readiness Standards for Government Human Capital Practices",
          "Human Capital Future Readiness",
          "Future Readiness Index",
          "Government Human Capital Future Readiness Accreditation",
          "Future Readiness Accreditation",
          "Government Human Capital Future Readiness Index",
          "Future Readiness Research & Studies",
          "FROI's Future Ready Government Human Capital Model",
        ].join(", ")}
        OGDescription="FROI is grounded in a rigorous scientific methodology engineered to navigate the demands of the New Economy , Future Ways of Work, as well as to empower the government human capital ecosystem to transition from merely anticipating the future to actively shaping it."
        url="https://www.froiglobal.org/"
      />{" "}
      <motion.section className="froi_section">
        <Container>
          <TypeIt
            element="h1"
            className="froi_title"
            options={{
              speed: 50,
              waitUntilVisible: true,
              cursor: false,
              lifeLike: true,
            }}
          >
            The Future Ready Organization{" "}
            <span className="marked_word model-appear">Institute</span>®
          </TypeIt>

          <p className="froi_text_desc">
            <strong>
              FRO<span className="marked_word">I</span>
            </strong>{" "}
            is the Global Authority dedicated to designing and developing <br />
            the{" "}
            <strong>
              Future Readiness Standards for Government Human Capital Practices.
            </strong>
          </p>
          <Row>
            <Col lg={7} xs={7}>
              <div className="div_line"></div>
            </Col>
          </Row>
          <Row className="froi_brand_section">
            <Col lg={6} xs={12}>
              <div className="froi_brand_text">
                <p className="froi_text">
                  <strong>FROI</strong> is grounded in a rigorous scientific
                  methodology engineered to navigate the demands of the New
                  Economy, Future Ways of Work, as well as to empower the
                  government human capital ecosystem to transition from merely
                  anticipating the future to actively shaping it.
                </p>
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <motion.div
                className="froi_brand_img"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ amount: 0.5 }}
                transition={{
                  duration: 0.9,
                  ease: "easeInOut",
                  delay: 0.8,
                }}
              >
                <img
                  src={"./images/about/about_page_side_message.png"}
                  alt={"froi-about-message"}
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </motion.section>
      <FroiCards />
    </>
  );
}

export default AboutPage;
